import { useAuthStore } from '@shared/stores/authStore';
import { usePermissions } from '@shared/hooks/usePermissions';

/**
 * Hook para verificar si CRM está habilitado según los settings del usuario
 * Usa el store directamente para evitar esperar a que /me responda
 */
export const useCRMEnabled = () => {
  const authStore = useAuthStore();

  // Obtener crmEnabled directamente del store (ya está persistido)
  const crmEnabled = authStore.getCRMEnabled();

  return {
    crmEnabled,
    isLoading: false, // Ya no depende de currentUser, siempre está disponible desde el store
  };
};

/**
 * Hook para verificar si el usuario puede gestionar CRM
 * Retorna false si es tenant_external y crm.managed_by es tenant_3pl
 * Usa el store directamente para evitar esperar a que /me responda
 */
export const useCanManageCRM = () => {
  const authStore = useAuthStore();
  const { getTeamType } = usePermissions();

  const teamType = getTeamType();
  const crmManagedBy = authStore.getCRMManagedBy();
  const canManage = authStore.canManageCRM();

  return {
    canManage,
    isLoading: false, // Ya no depende de currentUser, siempre está disponible desde el store
    crmManagedBy,
  };
};
